import { lazy } from 'react';
import {
  IconBook,
  IconCodeSandbox,
  IconCommon,
  IconMessage,
  IconSave,
  IconUserGroup,
  IconUnorderedList,
  IconCalendar,
  IconTag,
} from '@arco-design/web-react/icon';
const Login = lazy(() => import('./pages/Login'));
const Trading = lazy(() => import('./pages/Trading'));
const Catalogs = lazy(() => import('./pages/Catalog'));

// 订购单管理
const ContractList = lazy(() =>
  import('./pages/ContractV2/ContractList').then((res) => ({
    default: res.ContractList,
  }))
);

// 订购单管理-新增合同
const ContractNew = lazy(() =>
  import('./pages/ContractV2/ContractEdit').then((res) => ({
    default: res.ContractEdit,
  }))
);

const OrdersEdit = lazy(() =>
  import('./pages/Contract/OrdersEdit').then((res) => ({
    default: res.OrdersEdit,
  }))
);

const ContractDetail = lazy(() =>
  import('./pages/Contract/ContractDetail').then((res) => ({
    default: res.ContractDetail,
  }))
);

const TaskEdit = lazy(() =>
  import('./pages/Contract/TaskEdit').then((res) => ({
    default: res.TaskEdit,
  }))
);

const PrototypeList = lazy(() =>
  import('./pages/Prototype/List').then((res) => ({
    default: res.PrototypeList,
  }))
);

const PrototypeEdit = lazy(() =>
  import('./pages/Prototype/Edit').then((res) => ({
    default: res.PrototypeEdit,
  }))
);

const WebCatalogList = lazy(() =>
  import('./pages/WebCatalog/List').then((res) => ({
    default: res.WebCatalogList,
  }))
);

const WebCatalogEdit = lazy(() =>
  import('./pages/WebCatalog/Edit').then((res) => ({
    default: res.WebCatalogEdit,
  }))
);

const ClientList = lazy(() =>
  import('./pages/Client/List').then((res) => ({
    default: res.ClientList,
  }))
);

const ClientEdit = lazy(() =>
  import('./pages/Client/Edit').then((res) => ({
    default: res.ClientEdit,
  }))
);

const ClientDetail = lazy(() =>
  import('./pages/Client/Detail').then((res) => ({
    default: res.ClientDetail,
  }))
);

const MessageList = lazy(() =>
  import('./pages/ClientMessage/List').then((res) => ({
    default: res.ClientMessageList,
  }))
);

const QuoteSheetList = lazy(() =>
  import('./pages/QuoteSheet/List').then((res) => ({
    default: res.QuoteSheetList,
  }))
);

const QuoteSheetEdit = lazy(() =>
  import('./pages/QuoteSheet/Edit').then((res) => ({
    default: res.QuoteSheetEdit,
  }))
);

const ResponseTracking = lazy(() =>
  import('./pages/ResponseTracking').then((res) => ({
    default: res.ResponseTracking,
  }))
);

const Fabric = lazy(() =>
  import('./pages/Fabric').then((res) => ({
    default: res.Fabric,
  }))
);

const LabelCollectionList = lazy(() =>
  import('./pages/Label/List').then((res) => ({
    default: res.LabelCollectionList,
  }))
);

const LabelCollectionEdit = lazy(() =>
  import('./pages/Label/Edit').then((res) => ({
    default: res.LabelCollectionEdit,
  }))
);

const FactoryTask = lazy(() =>
  import('./pages/FactoryTask/index').then((res) => ({
    default: res.FactoryTask,
  }))
);

export enum SUB_MENU {
  FACTORY = 'FACTORY',
  COMMERCE = 'COMMERCE',
  UTILITY = 'UTILITY',
}

export const SubMenuTitle: Record<SUB_MENU, string> = {
  [SUB_MENU.FACTORY]: '工厂',
  [SUB_MENU.COMMERCE]: '贸易',
  [SUB_MENU.UTILITY]: '工具',
};

const routes = [
  {
    path: '/',
    exact: true,
    title: '首页',
    name: 'INDEX',
    accesses: ['INDEX'],
    main: ContractList,
    hiddenInNav: true,
  },
  {
    path: '/login',
    exact: true,
    title: '登陆',
    name: 'LOGIN',
    accesses: ['LOGIN'],
    main: Login,
    hiddenInNav: true,
  },
  {
    path: '/contract/list',
    exact: true,
    title: '合同列表',
    subMenu: SUB_MENU.FACTORY,
    subMenuTitle: '工厂',
    icon: <IconSave />,
    name: 'CONTRACT',
    accesses: ['CONTRACT'],
    main: ContractList,
  },
  {
    path: '/contract/:contract_id/purchase/create',
    exact: true,
    title: '创建订购单',
    name: 'PURCHASE',
    accesses: ['PURCHASE'],
    hiddenInNav: true,
    main: OrdersEdit,
  },
  {
    path: '/contract/:contract_id/task/create',
    exact: true,
    title: '创建生产单',
    name: 'CONTRACT',
    accesses: ['FACTORY-TASK-EDIT'],
    hiddenInNav: true,
    main: TaskEdit,
  },
  {
    path: '/contract/:contract_id/purchase/:order_id/edit',
    exact: true,
    title: '编辑订购单',
    name: 'PURCHASE',
    accesses: ['PURCHASE'],
    hiddenInNav: true,
    main: OrdersEdit,
  },
  {
    path: '/contract/:contract_id/task/:task_id/edit',
    exact: true,
    title: '修改工艺单',
    name: 'CONTRACT',
    accesses: ['FACTORY-TASK-EDIT'],
    hiddenInNav: true,
    main: TaskEdit,
  },
  {
    path: '/contract/create',
    exact: true,
    title: '新增合同',
    name: 'CONTRACT',
    accesses: ['CONTRACT'],
    hiddenInNav: true,
    main: ContractNew,
  },
  {
    path: '/contract/:contract_id/detail',
    exact: true,
    title: '合同详情',
    name: 'CONTRACT',
    accesses: ['PURCHASE'],
    hiddenInNav: true,
    main: ContractDetail,
  },
  {
    path: '/fabric/list',
    exact: true,
    title: '面料价格',
    subMenu: SUB_MENU.FACTORY,
    subMenuTitle: '工厂',
    icon: <IconTag />,
    name: 'FABRIC',
    accesses: ['FABRIC'],
    main: Fabric,
  },
  {
    path: '/client/list',
    exact: true,
    title: '客户列表',
    subMenu: SUB_MENU.COMMERCE,
    subMenuTitle: '贸易',
    icon: <IconUserGroup />,
    name: 'CLIENT',
    accesses: ['CLIENT'],
    main: ClientList,
  },
  {
    path: '/client/create',
    exact: true,
    title: '新增客户',
    icon: <IconUserGroup />,
    name: 'CLIENT',
    accesses: ['CLIENT'],
    main: ClientEdit,
    hiddenInNav: true,
  },
  {
    path: '/client/:client_id/edit',
    exact: true,
    title: '编辑客户',
    icon: <IconUserGroup />,
    name: 'CLIENT',
    accesses: ['CLIENT'],
    main: ClientEdit,
    hiddenInNav: true,
  },
  {
    path: '/client/:client_id',
    exact: true,
    title: '客户进度详情',
    icon: <IconUserGroup />,
    name: 'CLIENT',
    accesses: ['CLIENT'],
    main: ClientDetail,
    hiddenInNav: true,
  },
  {
    path: '/messages/list',
    exact: true,
    title: '客户询盘',
    subMenu: SUB_MENU.COMMERCE,
    subMenuTitle: '贸易',
    icon: <IconMessage />,
    name: 'MESSAGE',
    accesses: ['MESSAGE'],
    main: MessageList,
  },
  {
    path: '/response',
    exact: true,
    title: '跟进记录',
    subMenu: SUB_MENU.COMMERCE,
    subMenuTitle: '贸易',
    icon: <IconMessage />,
    name: 'RESPONSE',
    accesses: ['RESPONSE'],
    main: ResponseTracking,
  },
  {
    path: '/prototype/list',
    exact: true,
    title: '样品列表',
    subMenu: SUB_MENU.COMMERCE,
    subMenuTitle: '贸易',
    icon: <IconCodeSandbox />,
    name: 'PROTOTYPE',
    accesses: ['PROTOTYPE'],
    main: PrototypeList,
  },
  {
    path: '/prototype/create',
    exact: true,
    title: '新增样品',
    icon: <IconCodeSandbox />,
    name: 'PROTOTYPE',
    accesses: ['PROTOTYPE'],
    main: PrototypeEdit,
    hiddenInNav: true,
  },
  {
    path: '/prototype/:prototype_id/edit',
    exact: true,
    title: '编辑样品',
    icon: <IconCodeSandbox />,
    name: 'PROTOTYPE',
    accesses: ['PROTOTYPE'],
    main: PrototypeEdit,
    hiddenInNav: true,
  },
  {
    path: '/webcatalog/list',
    exact: true,
    title: '产品目录',
    subMenu: SUB_MENU.COMMERCE,
    subMenuTitle: '贸易',
    icon: <IconBook />,
    name: 'WEBCATALOG',
    accesses: ['WEBCATALOG'],
    main: WebCatalogList,
  },
  {
    path: '/webcatalog/create',
    exact: true,
    title: '产品目录',
    icon: <IconBook />,
    name: 'WEBCATALOG',
    accesses: ['WEBCATALOG'],
    main: WebCatalogEdit,
    hiddenInNav: true,
  },
  {
    path: '/webcatalog/:webcatalog_id/edit',
    exact: true,
    title: '产品目录',
    icon: <IconBook />,
    name: 'WEBCATALOG',
    accesses: ['WEBCATALOG'],
    main: WebCatalogEdit,
    hiddenInNav: true,
  },
  {
    path: '/quotesheet/list',
    exact: true,
    title: '询价历史',
    subMenu: SUB_MENU.COMMERCE,
    subMenuTitle: '贸易',
    icon: <IconTag />,
    name: 'QUOTESHEET',
    accesses: ['QUOTESHEET'],
    main: QuoteSheetList,
  },
  {
    path: '/quotesheet/create',
    exact: true,
    title: '询价历史',
    icon: <IconTag />,
    name: 'QUOTESHEET',
    accesses: ['QUOTESHEET'],
    main: QuoteSheetEdit,
    hiddenInNav: true,
  },
  {
    path: '/quotesheet/:quotesheet_request_id/edit',
    exact: true,
    title: '询价历史',
    icon: <IconTag />,
    name: 'QUOTESHEET',
    accesses: ['QUOTESHEET'],
    main: QuoteSheetEdit,
    hiddenInNav: true,
  },
  {
    path: '/trading',
    title: '贸易产品',
    icon: <IconCodeSandbox />,
    name: 'TRADING',
    accesses: ['TRADING'],
    hiddenInNav: true,
    main: Trading,
  },
  {
    path: '/catalogs',
    title: '电子目录',
    icon: <IconCommon />,
    name: 'CATALOG',
    accesses: ['CATALOG'],
    hiddenInNav: true,
    main: Catalogs,
  },
  {
    path: '/utility/label-collections',
    exact: true,
    title: '洗标制作',
    subMenu: SUB_MENU.UTILITY,
    subMenuTitle: '工具',
    icon: <IconUnorderedList />,
    name: 'UTILITY-LABEL',
    accesses: ['UTILITY-LABEL'],
    main: LabelCollectionList,
  },
  {
    path: '/utility/label-collections/:label_collection_id',
    exact: true,
    title: '洗标制作',
    icon: <IconUnorderedList />,
    name: 'UTILITY-LABEL',
    accesses: ['UTILITY-LABEL'],
    hiddenInNav: true,
    main: LabelCollectionEdit,
  },
  {
    path: '/factory/tasks',
    exact: true,
    title: '生产总览',
    subMenu: SUB_MENU.FACTORY,
    subMenuTitle: '工厂',
    icon: <IconCalendar />,
    name: 'FACTORY-TASK',
    accesses: ['FACTORY-TASK-VIEW', 'FACTORY-TASK-EDIT'],
    main: FactoryTask,
  },
];

export default routes;
